import { useEffect, useState } from "react";
import { Keyboard, Platform, KeyboardEventName } from "react-native";

const { show, hide, changeFrame } = Platform.select<{
  show: KeyboardEventName;
  hide: KeyboardEventName;
  changeFrame: KeyboardEventName;
}>({
  default: { show: "keyboardWillShow", hide: "keyboardWillHide", changeFrame: "keyboardWillChangeFrame" },
  android: { show: "keyboardDidShow", hide: "keyboardDidHide", changeFrame: "keyboardDidChangeFrame" },
});

export default function useKeyboard() {
  const [isKeyboardVisible, setKeyboardVisible] = useState(false);
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    const listeners = [
      Keyboard.addListener(show, (e) => {
        setKeyboardHeight(e.endCoordinates.height);
        setKeyboardVisible(true);
      }),
      Keyboard.addListener(hide, () => {
        setKeyboardHeight(0);
        setKeyboardVisible(false);
      }),
      Keyboard.addListener(changeFrame, (e) => {
        setKeyboardHeight(e.endCoordinates.height);
      }),
    ];

    return () => {
      listeners.forEach((listener) => listener.remove());
    };
  }, []);

  return {
    isKeyboardVisible,
    keyboardHeight,
  };
}
